<template>
  <div style="width: 100%">
    <div style="display:flex;justify-content:space-between;align-items:flex-end;padding-top:5px;">
      <b-form-group
        style="width: 15%;"
      >
        <vue-select
          v-model="supplierId"
          :options="getSupplierDropDown"
          label="supplierName"
          :reduce="(e) => e.supplierId"
          :placeholder="$t('Main')"
          aria-describedby="input-1-live-feedback"
          :clearable="true"
          :disabled="!from || !to"
          @input="handleChange"
        />
      </b-form-group>
      <div class="inputs">
        <b-form-group
          :label="$t('StartDate')"
        >
          <date-picker
            v-model="from"
            value-type="format"
            :placeholder="$t('SelectD')"
            :format="'YYYY-MM-DD'"
            :clearable="false"
            :lang="lang"
          />
        </b-form-group>
        <b-form-group
          :label="$t('EndDate')"
        >
          <date-picker
            v-model="to"
            value-type="format"
            :placeholder="$t('SelectD')"
            :format="'YYYY-MM-DD'"
            :clearable="false"
            :lang="lang"
          />
        </b-form-group>
        <PdfDocument
          :method-name="'costCardBySupplier'"
          :getter-name="'getCostCardBySupplier'"
          :pdf-name="'PurchaseBook'"
          :is-pagination="false"
          :header-name="header"
          :object-value="objectPDF"
          :start-date="from"
          :end-date="to"
          :pdf-title="$t('PurchaseBook')"
        />
        <img
          v-b-tooltip.hover="$t('DownloadExcel')"
          style="cursor:pointer;"
          src="../../assets/images/pdf-invoice-logo.svg"
          @click="downloadEXCEL"
        >
      </div>
    </div>
    <div style="height: 72vh; overflow-y: scroll;padding-top:10px;">
      <table
        ref="exportable_table"
        class="team_table"
      >
        <thead style="position: sticky; top: -2px">
          <tr>
            <th>
              {{ $t('SupplierName') }}
            </th>
            <th>
              {{ $t('Created') }}
            </th>
            <th>
              {{ $t('MaterialVariantName') }}
            </th>
            <th>
              {{ $t('Amount') }}
            </th>
            <th>
              {{ $t('Price') }}
            </th>
            <th>
              {{ $t('TotalPrice') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          :is-loading="isRequestLoading('costCardBySupplier')"
          :response-data="getCostCardBySupplier"
        >
          <tr
            v-for="(card, index) in getCostCardBySupplier"
            :key="index"
          >
            <td>{{ card.supplierName }}</td>
            <td>{{ convertUTCDateToLoacalDate(card.created) }}</td>
            <td>{{ card.materialVariantName }}</td>
            <td>{{ numbersWithcomma(card.amount) }}</td>
            <td>{{ numbersWithcomma(card.orderedPrice) }}</td>
            <td>{{ numbersWithcomma(card.amount * card.orderedPrice) }}</td>
          </tr>
        </LoadingSpinnerTable>
      </table>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment'
import 'vue2-datepicker/index.css';
import 'jspdf-autotable';
import { mapGetters, mapActions } from 'vuex';
import PdfDocument from '@/components/PdfDocument/DownloadPDF.vue'
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export default {
  components: {
    DatePicker,
    PdfDocument,
  },
  data() {
    return {
      supplierId: null,
      from: null,
      to: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      header: [
        {
          supplierName: 'Supplier Name', created: 'Created', materialVariantName: 'Material Variant Name', amount: 'Amount', orderedPrice: 'Ordered Price', totalPrice: 'Total Price',
        },
      ],
      objectPDF: {
        from: this.from,
        to: this.to,
        supplierId: null,
      },
    }
  },
  computed: {
    ...mapGetters([
      'getSuppliers',
      'getCostCardBySupplier',
      'getSupplierDropDown',
    ]),
  },
  watch: {
    from() {
      if (this.from && this.to) {
        this.callCardCost();
      }
    },
    to() {
      if (this.from && this.to) {
        this.callCardCost();
      }
    },
    supplierId() {
      if (this.from && this.to) {
        this.callCardCost();
      }
    },
  },
  mounted() {
    this.suppliersDropDown({
      isActive: true,
    })
  },
  methods: {
    ...mapActions(['costCardBySupplier', 'suppliersDropDown']),
    handleChange() {
      this.costCardBySupplier({
        from: this.from,
        to: this.to,
        supplierId: null,
      })
    },
    callCardCost() {
      this.costCardBySupplier({
        from: this.from,
        to: this.to,
        supplierId: this.supplierId,
      })
    },
    convertUTCDateToLoacalDate(date) {
      const local = moment.utc(date).local().format('DD-MMM-YYYY h:mm A')
      return local
    },
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    generateTableContentCSV(data) {
      const headers = ['Supplier Name', 'Created', 'Material Variant Name', 'Amount', 'Ordered Price'];
      const body = data.map((item) => {
        return [
          item.supplierName,
          this.convertUTCDateToLoacalDate(item.created),
          item.materialVariantName,
          this.numbersWithcomma(item.amount),
          this.numbersWithcomma(item.orderedPrice),
        ]
      });
      return { headers, body };
    },
    generateExcel(tableContent) {
      const { headers, body } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      return excelData;
    },
    downloadEXCEL() {
      this.costCardBySupplier({
        from: this.from,
        to: this.to,
        supplierId: this.supplierId,
      }).then(() => {
        const tableContent = this.generateTableContentCSV(this.getCostCardBySupplier)

        const totalPages = this.getCostCardBySupplier;
        const additionalPromises = [];
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          additionalPromises.push(this.downloadPage(pageNumber));
        }

        Promise.all(additionalPromises).then((additionalTableContents) => {
          additionalTableContents.forEach((additionalTableContent) => {
            tableContent.body = tableContent.body.concat(additionalTableContent.body);
          });

          const excelData = this.generateExcel(tableContent);
          FileSaver.saveAs(excelData, 'PurchaseBook.xlsx');
        })
      });
    },
  },
}
</script>

<style>
.pt-0 {
  padding-bottom: 0px !important;
}
.inputs {
  display: flex;
  justify-content:end;
  align-items:flex-end;
  width: 100%;
  gap: 5px;
}
.team_table td {
  padding: 16px 9px !important;
}
</style>
